import { Product } from "@utils/types";
import * as React from "react";
import Styled from "./styled";
import noimage from "@assets/img/noimage.jpeg";
import { Money } from "@utils/currency";
import { FaShoppingCart } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import Badge from "react-bootstrap/Badge";

type Props = {
  product: Product;
};

const ProductListItem: React.FC<Props> = ({ product }) => {
  const image = product.images?.filter((i) => !i.deleted_at)?.[0];
  const emptyStock = product.stock_quantity === 0 && product.stock_enabled;
  return (
    <Styled.Container to={`produto/${product.id}`} className="hover:none" id={`product_item_${product.id}`}>
      <Styled.Image src={image ? `${image.base_url}/products/${product.id}/thumb_2/${image.key}` : noimage} />
      <Styled.DescriptionContainer>
        <Styled.Description>{product.name}</Styled.Description>
        <Styled.Price>
          <div className="">
            <b>{product.lowest_price && Money(product.lowest_price).format()}</b>
            {emptyStock ? (
              <Badge className="py-2 w-100 my-2 justify-content-center" bg="secondary">
                <div className="d-flex justify-content-center">
                  <MdCancel className="mx-2" />
                  Indisponível
                </div>
              </Badge>
            ) : (
              <Badge className="py-2 w-100 my-2" bg="success">
                <div className="d-flex justify-content-center">
                  <FaShoppingCart className="mx-2" />
                  Comprar
                </div>
              </Badge>
            )}
          </div>
        </Styled.Price>
      </Styled.DescriptionContainer>
    </Styled.Container>
  );
};

export default ProductListItem;
